import { render, staticRenderFns } from "./uploadClass.vue?vue&type=template&id=cb10f43e&scoped=true"
import script from "./uploadClass.vue?vue&type=script&lang=js"
export * from "./uploadClass.vue?vue&type=script&lang=js"
import style0 from "./uploadClass.vue?vue&type=style&index=0&id=cb10f43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb10f43e",
  null
  
)

export default component.exports